import { AdKind, AdPage, AdsPlacementModel } from '@marketplace-web/ads/ads-data'

export function getAdPlacementId(placementConfig: AdsPlacementModel) {
  let code = ''
  const separator = '_'

  if ([AdKind.Rtb, AdKind.Van].includes(placementConfig.kind)) {
    code = [
      placementConfig.countryCode,
      placementConfig.platform,
      placementConfig.page,
      placementConfig.shape,
    ].join(separator)
  }

  if (placementConfig.mediation) {
    code = [code, placementConfig.mediation].join(separator)
  }

  return code
}

export const getRoktPlacementId = (placement: AdsPlacementModel | undefined): string | null => {
  if (!placement) return null

  const { countryCode, platform, shape, mediation } = placement

  return `${countryCode}_${platform}_${AdPage.PostTransaction}_${shape}_${mediation}`
}

export const MOCK_AD_SAMPLE_HTML = `
<!DOCTYPE html>
<html>
  <head>
    <title>Target All 1</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </head>
  <body>
    <a href="https://target.link.com" target="_top">
      <img src="https://img.url.com" alt="" />
    </a>
  </body>
</html>
`
